import React, { type CSSProperties } from "react";
import { cn } from "@ndd/ui";
import { FUNNEL_BAR_CLASSES, type FunnelStepView } from "../../../lib/metrics-display";

/** Diagonal hatching for the Medicare 3-session-cap segment (hatched in code per the design). */
export function MedicareHatch({
  patternId,
  label,
  className,
  style,
}: {
  patternId: string;
  label: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      role="img"
      aria-label={label}
      className={className}
      style={style}
      preserveAspectRatio="none"
    >
      <defs>
        <pattern
          id={patternId}
          width="6"
          height="6"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="6" height="6" className="fill-sand-300" />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="6"
            strokeWidth="2"
            className="stroke-sand-500"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}

export function FunnelBar({
  step,
  medicareCapped,
}: {
  step: FunnelStepView;
  medicareCapped: number;
}) {
  const hasMedicareSegment = step.medicareSharePercent > 0;

  return (
    <div className="relative h-6 min-w-0 flex-1 overflow-hidden rounded-[4px] bg-muted">
      <div
        className={cn("relative h-full rounded-[4px]", FUNNEL_BAR_CLASSES[step.status])}
        style={{ width: `${step.sharePercent}%` }}
      >
        <span className="absolute inset-y-0 left-2 flex items-center whitespace-nowrap text-body-sm text-foreground">
          {step.patients} patients
        </span>
      </div>
      {hasMedicareSegment && (
        <MedicareHatch
          patternId={`medicare-hatch-${step.id}`}
          label={`${medicareCapped} patients reached the Medicare 3-session cap here`}
          className="absolute inset-y-0 h-full"
          style={{
            left: `${step.sharePercent - step.medicareSharePercent}%`,
            width: `${step.medicareSharePercent}%`,
          }}
        />
      )}
    </div>
  );
}
